<ng-template #previewQuestionnaireModal let-modal>
  <div class="modal-content">
    <div class="modal-header">
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="modal.close('Close click')"></button>
    </div>
    @if (loading) {
      <div class="modal-body w-100 p-4 questionaireBg">
        <div class="text-center py-5">
          <app-loading-spinner></app-loading-spinner>
        </div>
      </div>
    }
    @if (!loading) {
      <div class="modal-body w-100 p-4 questionaireBg" [ngClass]="questionnaire.lang_code === 'he' ? 'rtl' : 'ltr'">
        @if (showDesc) {
          <div>
            <h4 class="font-weight-bold">{{ 'ASSESSMENTAPP.DESCRIPTION' | translate}}</h4>
            <div class="ql-container ql-snow" style="border-width: 0;">
              <div class="ql-editor" [innerHTML]="questionnaire.description"></div>
            </div>
            @if (!questionnaire.description) {
              <div>
                <h3 class="text-center pt-5 text-warning">{{ 'ASSESSMENTAPP.NO_DESCRIPTION' | translate }}</h3>
              </div>
            }
          </div>
        }
        @if (showQuestion) {
          <div class="questionaireSectionMain">
            <app-view-chapter-question [question_index]="questionIndex" [question_length]="question_length" [chapter_name]="chapter_name" [lang_code]="questionnaire.lang_code" [question]="currentViewQuestion" [questionID]="'question-' + questionIndex"></app-view-chapter-question>
          </div>
        }
        <div class="btn-group w-100 pt-4">
          <div>
            @if (showQuestion) {
              <button (click)="backQuestion()" type="button" class="btn btn-secondary">{{ 'ASSESSMENTAPP.BACK' | translate}}</button>
            }
          </div>
          @if (showNext) {
            <div [ngClass]="questionnaire.lang_code === 'he' ? 'me-auto' : 'ms-auto'">
              <button (click)="nextQuestion()" type="button" class="btn btn-secondary">{{ 'ASSESSMENTAPP.NEXT' | translate}}</button>
            </div>
          }
        </div>
      </div>
    }
  </div>
</ng-template>